import { type RadarPrediction, slugify } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export function getRadarPredictionId(prediction: RadarPrediction) {
  const { formattedAddress, latitude, longitude, layer } = prediction;

  return `${slugify(formattedAddress)}-${latitude}-${longitude}-${layer}`;
}
